// Der Rücksprung an den Seitenanfang erscheint, sobald die Unterkante der ersten
// Inhalts-Section die Unterkante des Fensters erreicht — vorher liest man noch im
// ersten Abschnitt, und dort führt die Sprungmarken-Leiste nach unten statt
// zurück nach oben.
//
// Die Bühne zählt nicht als Inhalt: sie ist die Kopfsektion und trägt eben jene
// Leiste. Übersprungen wird sie über ihre Klasse (`section-stage`,
// `section-stage-switch`), nicht über die Position — auf Seiten ohne Bühne ist
// die erste Section schon der Inhalt.
//
// Entschieden wird aus der Geometrie, der IntersectionObserver liefert nur den
// Anlass zum Nachrechnen: seine Wurzel ist eine Zeile an der Fensterunterkante,
// und die Section kreuzt sie genau dann, wenn die Bedingung umschlägt. Ein
// blosses `isIntersecting` genügt nicht — „schneidet nicht" gilt oberhalb der
// Zeile wie unterhalb, und beim Seitenaufruf liegt der Abschnitt noch unter dem
// Fenster.
//
// Bewusst kein Vue, wie beim Markenwechsel der Stage: keine Reaktivität nötig,
// und ein Renderfehler in der In-DOM-Kompilierung würde die ganze Seite
// verwerfen. Dafür muss init() NACH app.mount() laufen.
//
// Ohne dieses Skript bleibt die Platte durchweg sichtbar — die Klasse
// `back-to-top--auto`, an der die Verdeckung im SCSS hängt, setzt erst das Modul.

// Prozent statt Pixel, damit die Zeile ohne Zutun mitwandert: die Wurzel wird in
// jedem Frame aus der aktuellen Fenstergrösse gerechnet, ein resize-Handler oder
// eine gemerkte Höhe erübrigt sich. Das eine Pixel ist keine Layoutgrösse,
// sondern die kleinste Zeile, die überhaupt schneiden kann — eine Wurzel ohne
// Höhe trifft nie.
const ROOT_MARGIN = "-100% 0px 1px 0px";

function isStage(section) {
    return [...section.classList].some((name) => name.startsWith("section-stage"));
}

function firstContentSection() {
    return [...document.querySelectorAll("#content > .section")].find(
        (section) => !isStage(section)
    );
}

function start(link) {
    const first = firstContentSection();

    if (!first) {
        return;
    }

    // Ab hier entscheidet das Skript; vorher gibt es keinen verdeckten Zustand.
    link.classList.add("back-to-top--auto");

    const update = () => {
        const reached = first.getBoundingClientRect().bottom <= window.innerHeight;

        link.classList.toggle("is-visible", reached);
    };

    // Den ersten Aufruf macht der Observer selbst — er meldet die Ausgangslage,
    // auch bei einem Seitenaufruf mitten im Dokument (Sprungmarke, Rücktaste).
    new IntersectionObserver(update, { rootMargin: ROOT_MARGIN }).observe(first);
}

export function initBackToTop(root = document) {
    root.querySelectorAll(".back-to-top").forEach(start);
}
